<template>
  <div class="device-trace">
    <!-- 返回按钮 -->
    <div class="page-header">
      <el-button
          type="text"
          icon="el-icon-back"
          @click="goBack"
          size="medium"
      >
        返回首页
      </el-button>
    </div>

    <div class="trace-container">
      <h2 class="page-title">设备溯源查询</h2>

      <el-tabs v-model="activeName" type="card" class="barcode-tabs">
        <!-- 手机扫 tab -->
        <el-tab-pane label="手机扫" name="first">
          <div class="tab-content phone-tab">
            <!-- 扫描区域：查询到结果后隐藏 -->
            <div class="scanner-section" v-if="showScanner">
              <div class="scanner-wrapper">
                <div id="phone-reader" class="reader-container"></div>
                <div class="scan-overlay" v-show="phoneScanning">
                  <div class="scan-line horizontal"></div>
                </div>
              </div>

              <div class="controls">
                <el-button
                    type="primary"
                    size="medium"
                    :disabled="phoneScanning || !phoneCameras.length"
                    @click="phoneStartScanning"
                    style="flex: 1;"
                >
                  开始扫描
                </el-button>
                <el-button
                    type="danger"
                    size="medium"
                    :disabled="!phoneScanning"
                    @click="phoneStopScanning"
                    style="flex: 1; margin-left: 0px;"
                >
                  停止
                </el-button>
                <el-button
                    type="info"
                    size="medium"
                    @click="phoneSwitchCamera"
                    :disabled="!phoneCameras.length || phoneCameras.length <= 1"
                    style="flex: 1; margin-left: 0px;"
                >
                  切换摄像头
                </el-button>
              </div>

              <div class="status-box" v-if="phoneStatusMessage">
                {{ phoneStatusMessage }}
              </div>
              <el-alert
                  v-if="phoneErrorMessage"
                  title="提示"
                  type="error"
                  :description="phoneErrorMessage"
                  show-icon
                  :closable="true"
                  @close="phoneErrorMessage = ''"
                  style="margin-top: 10px;"
              />
            </div>

            <!-- 溯源结果 -->
            <div class="trace-result" v-if="traceResult">
              <el-card class="device-info-card">
                <div slot="header">
                  <span>设备基本信息</span>
                </div>
                <div class="info-row">
                  <span class="label">设备名称：</span>
                  <span class="value">{{ traceResult.name || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">规格型号：</span>
                  <span class="value">{{ traceResult.code || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">当前状态：</span>
                  <el-tag :type="traceResult.status === '在库' ? 'success' : 'warning'">
                    {{ traceResult.status || '未知' }}
                  </el-tag>
                </div>
              </el-card>

              <div class="history-section" v-if="traceResult.history && traceResult.history.length">
                <h4 class="section-title">出入库节点历史</h4>
                <el-timeline >
                  <el-timeline-item
                      v-for="(event, index) in traceResult.history"
                      :key="index"
                      :timestamp="event.state"
                      :color="event.type === '1' ? '#67C23A' : '#E6A23C'"
                      placement="top"
                  >
                    <el-card class="history-card" shadow="hover">
                      <div class="event-content">
                        <el-tag
                            :type="event.type === '1' ? 'success' : 'warning'"
                            size="small"
                            effect="dark"
                        >
                        {{formatecktype(event.sstype)}}
                        </el-tag>

                        <el-tag
                            type="info"
                            size="small"
                            effect="plain"
                            class="company-tag"
                        >
                          {{ formatecid(event.cid) }}
                        </el-tag>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>

              <div v-else class="no-history">
                暂无出入库历史记录
              </div>

              <!-- 重新扫描按钮 -->
              <div style="text-align: center; margin-top: 30px;">
                <el-button type="primary" plain @click="resetScan">
                  重新扫描其他设备
                </el-button>
              </div>
            </div>

            <!-- 无结果提示（扫描区隐藏且无结果时显示） -->
            <div v-if="!showScanner && !traceResult" class="no-result-tip">
              暂无查询结果，请扫描条码
            </div>
          </div>
        </el-tab-pane>

        <!-- 扫码枪 tab -->
        <el-tab-pane label="扫码枪" name="second" v-if="devicetype === 'pc'">
          <div class="tab-content">
            <div class="scanner-card">
              <h3 class="card-title">扫码枪快速溯源</h3>

              <!-- 扫描输入区：查询到结果后隐藏 -->
              <div v-if="showScanner">
                <el-input
                    v-model="scanCode"
                    ref="scanInput"
                    placeholder="对准条码扫描 → 自动查询"
                    clearable
                    autofocus
                    class="scan-input-large"
                    @keydown.enter.native="gunHandleScanEnter"
                />

                <div class="current-status" :class="gunStatus">
                  <span class="status-emoji">
                    <template v-if="gunStatus === 'loading'">⌛️</template>
                    <template v-else-if="gunStatus === 'success'">✅</template>
                    <template v-else-if="gunStatus === 'warning'">⚠️</template>
                    <template v-else-if="gunStatus === 'error'">❌</template>
                    <template v-else>⏳</template>
                  </span>
                  <span class="status-text">{{ gunStatusText || '等待扫描...' }}</span>
                </div>

                <div class="guide-text">
                  <p>扫码枪扫描后自动查询设备溯源信息</p>
                </div>

                <el-button type="primary" plain @click="gunFocusInput" class="focus-btn">
                  点击聚焦输入框
                </el-button>
              </div>

              <!-- 溯源结果 -->
              <div class="trace-result" v-if="traceResult">
                <el-card class="device-info-card">
                  <div slot="header">
                    <span>设备基本信息</span>
                  </div>
                  <div class="info-row">
                    <span class="label">设备PID：</span>
                    <span class="value">{{ traceResult.pid || '--' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="label">设备名称：</span>
                    <span class="value">{{ traceResult.name || '--' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="label">规格型号：</span>
                    <span class="value">{{ traceResult.code || '--' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="label">当前状态：</span>
                    <el-tag :type="traceResult.status === '在库' ? 'success' : 'warning'">
                      {{ traceResult.status || '未知' }}
                    </el-tag>
                  </div>
                </el-card>

                <div class="history-section" v-if="traceResult.history && traceResult.history.length">
                  <h4 class="section-title">出入库节点历史</h4>
                  <el-timeline >
                    <el-timeline-item
                        v-for="(event, index) in traceResult.history"
                        :key="index"
                        :timestamp="event.state"
                        :color="event.type === '1' ? '#67C23A' : '#E6A23C'"
                        placement="top"
                    >
                      <el-card class="history-card" shadow="hover">
                        <div class="event-content">
                          <el-tag
                              :type="event.type === '1' ? 'success' : 'warning'"
                              size="small"
                              effect="dark"
                          >
                            {{ formatecktype(event.sstype)}}
                          </el-tag>

                          <el-tag
                              type="info"
                              size="small"
                              effect="plain"
                              class="company-tag"
                          >
                            {{ formatecid(event.cid) }}
                          </el-tag>
                        </div>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                </div>

                <div v-else class="no-history">
                  暂无出入库历史记录
                </div>

                <div style="text-align: center; margin-top: 30px;">
                  <el-button type="primary" plain @click="resetScan">
                    重新扫描其他设备
                  </el-button>
                </div>
              </div>

              <div v-if="!showScanner && !traceResult" class="no-result-tip">
                暂无查询结果，请扫描条码
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {Html5Qrcode} from 'html5-qrcode'

export default {
  data() {
    return {
      devicetype: 'pc',
      activeName: 'first',

      productList: [],                // 用于格式化设备名称
      traceResult: null,              // 当前溯源结果
      showScanner: true,              // 控制扫描区域显示/隐藏

      // 手机扫
      phoneScanning: false,
      phoneCameras: [],
      phoneCurrentCameraId: null,
      phoneStatusMessage: '',
      phoneErrorMessage: '',
      phoneScanner: null,
      comList: [],
      rktypeList:[],
      // 扫码枪
      scanCode: '',
      gunStatus: '',
      gunStatusText: '等待扫描...'
    }
  },

  mounted() {
    this.getDic();
    this.getcom();
    this.getproductList()
    this.phoneInitScanner()
    this.devicetype = localStorage.getItem('deviceType') || 'pc'
    this.$nextTick(() => {
      if (this.activeName === 'second') this.gunFocusInput()
    })
  },

  beforeDestroy() {
    this.phoneStopScanning()
  },

  methods: {
    getDic() {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: 'rklx'},
        success: (data) => {
          this.rktypeList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    goBack() {
      this.$router.push('/')
    },

    // 重置扫描状态（点击“重新扫描”时）
    resetScan() {
      this.traceResult = null
      this.showScanner = true
      this.phoneStatusMessage = ''
      this.phoneErrorMessage = ''
      this.gunStatus = ''
      this.gunStatusText = '等待扫描...'
      // 可选：自动重新开启摄像头
      // if (this.activeName === 'first' && this.phoneCameras.length) {
      //   this.phoneStartScanning()
      // }
    },

    getproductList() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.productList = data.data || []
        },
        error: (error) => {
          console.error("获取商品列表失败:", error)
        }
      })
    },

    formatepid(pid) {
      const found = this.productList.find(item => item.id == pid)
      return found ? found.remark : pid || '--'
    },
    formatecid(cid) {
      const found = this.comList.find(item => item.id == cid)
      return found ? found.name : pid || '--'
    },
    formatecktype(cid) {
      const found = this.rktypeList.find(item => item.dictCode == cid)
      return found ? found.dictValue : pid || '--'
    },

    getcom() {
      this.$request.postHttp({
        url: "/basic/getcom",
        success: (data) => {
          this.comList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    // 统一处理扫码结果（手机 + 扫码枪共用）
    handleBarcode(barcode) {
      if (!barcode || barcode.length < 6) return

      this.phoneStatusMessage = this.gunStatusText = '查询中...'
      this.gunStatus = 'loading'

      this.$request.getHttp({
        url: "/basic/traceDevice",  // ← 替换成你的实际溯源接口
        params: {bm: barcode},
        success: (data) => {
          if (data.code === 200) {
            this.traceResult = data.data || null
            this.showScanner = false           // 成功后隐藏扫描区
            this.phoneStatusMessage = this.gunStatusText = '查询成功'
            this.gunStatus = 'success'
          } else {
            this.phoneStatusMessage = this.gunStatusText = data.msg || '查询失败'
            this.gunStatus = 'error'
            this.traceResult = null
          }
        },
        error: (err) => {
          console.error('溯源查询失败', err)
          this.phoneStatusMessage = this.gunStatusText = '查询失败，请重试'
          this.gunStatus = 'error'
          this.traceResult = null
        }
      })
    },

    // 手机扫完整方法
    async phoneInitScanner() {
      try {
        this.phoneScanner = new Html5Qrcode("phone-reader", {
          fps: 20,
          qrbox: {width: 400, height: 200},
          aspectRatio: 16 / 9,
          experimentalFeatures: {useBarCodeDetectorIfSupported: true}
        })

        const cams = await Html5Qrcode.getCameras()
        this.phoneCameras = cams
        const backCamera = cams.find(c => c.label.toLowerCase().includes('back') || c.label.toLowerCase().includes('rear'))
        this.phoneCurrentCameraId = backCamera ? backCamera.id : cams[0]?.id

        if (this.phoneCurrentCameraId) {
          this.phoneStatusMessage = '摄像头已准备好'
        } else {
          this.phoneErrorMessage = '未找到可用摄像头'
        }
      } catch (err) {
        this.phoneErrorMessage = '初始化失败：' + err.message
      }
    },

    async phoneStartScanning() {
      if (!this.phoneScanner || !this.phoneCurrentCameraId) return

      try {
        await this.phoneScanner.start(
            this.phoneCurrentCameraId,
            {
              fps: 30,
              qrbox: {width: 400, height: 200},
              aspectRatio: 16 / 9,
              videoConstraints: {facingMode: 'environment'}
            },
            this.phoneOnScanSuccess,
            () => {
            }
        )
        this.phoneScanning = true
        this.phoneStatusMessage = '正在扫描...'
      } catch (err) {
        this.phoneErrorMessage = '启动失败：' + err.message
      }
    },

    async phoneStopScanning() {
      if (this.phoneScanner && this.phoneScanning) {
        try {
          await this.phoneScanner.stop()
          this.phoneScanning = false
          this.phoneStatusMessage = '扫描已停止'
        } catch (err) {
          console.error(err)
        }
      }
    },

    async phoneSwitchCamera() {
      if (!this.phoneScanning || this.phoneCameras.length < 2) return

      const currentIndex = this.phoneCameras.findIndex(c => c.id === this.phoneCurrentCameraId)
      const nextIndex = (currentIndex + 1) % this.phoneCameras.length
      this.phoneCurrentCameraId = this.phoneCameras[nextIndex].id

      await this.phoneStopScanning()
      await this.phoneStartScanning()
    },

    phoneOnScanSuccess(decodedText) {
      const barcode = decodedText.trim()
      if (!barcode || barcode.length < 6) return

      this.phoneStopScanning()
      this.handleBarcode(barcode)
    },

    // 扫码枪方法
    gunFocusInput() {
      this.$refs.scanInput?.focus()
    },

    gunHandleScanEnter() {
      const code = this.scanCode.trim()
      if (!code) return

      this.gunStatus = 'loading'
      this.gunStatusText = '查询中...'

      this.handleBarcode(code)

      this.scanCode = ''
      this.$nextTick(() => this.gunFocusInput())
    }
  }
}
</script>

<style scoped>
.device-trace {
  padding: 20px;
}

.page-header {
  margin-bottom: 15px;
  text-align: left;
}

.page-title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  color: #303133;
}

.trace-container {
  max-width: 900px;
  margin: 0 auto;
}

.scanner-section {
  margin-bottom: 30px;
}

.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto 20px;
  border: 3px solid #409eff;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

.reader-container {
  width: 100%;
  aspect-ratio: 4 / 3;
}

.controls {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
  flex-wrap: wrap;
}

.status-box {
  text-align: center;
  padding: 12px;
  background: #e6f7ff;
  border-radius: 8px;
  color: #409eff;
  font-size: 16px;
  margin: 10px 0;
}

.trace-result {
  margin-top: 30px;
}

.device-info-card .el-card__header {
  font-weight: bold;
}

.info-row {
  margin: 12px 0;
  font-size: 15px;
}

.info-row .label {
  font-weight: bold;
  color: #606266;
  margin-right: 10px;
}

.history-section {
  margin-top: 20px;
}

.history-card {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.event-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.no-history, .no-result-tip {
  text-align: center;
  color: #909399;
  font-size: 16px;
  padding: 40px 0;
  background: #f5f7fa;
  border-radius: 8px;
  margin-top: 20px;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .controls .el-button {
    flex: 1;
  }
}
.event-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;          /* 标签之间的间距 */
  align-items: center;
  padding: 4px 0;
}

.company-tag {
  background-color: #f0f2f5;
  color: #606266;
  border-color: #dcdfe6;
}

.remark-tag {
  background-color: #ecf5ff;
  color: #409eff;
  border-color: #b3d8ff;
}

.is-remark {
  /* 如果某些 sstype 想突出，可以再加特殊颜色 */
}
</style>